export function convertTo12HourFormat(time24) {
  let [hours, minutes] = time24.split(":");
  hours = parseInt(hours);
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")} ${period}`;
}

const API_BASE_URL = "https://api-dear-lottery.threecircle5.com/api"